import { render, staticRenderFns } from "./master-data.vue?vue&type=template&id=2b78bbf2&scoped=true&"
import script from "./master-data.vue?vue&type=script&lang=js&"
export * from "./master-data.vue?vue&type=script&lang=js&"
import style0 from "./master-data.vue?vue&type=style&index=0&id=2b78bbf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b78bbf2",
  null
  
)

export default component.exports